import { render, staticRenderFns } from "./statementconciliation.vue?vue&type=template&id=63fc3a3e&scoped=true"
import script from "./statementconciliation.vue?vue&type=script&lang=js"
export * from "./statementconciliation.vue?vue&type=script&lang=js"
import style0 from "./statementconciliation.vue?vue&type=style&index=0&id=63fc3a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc3a3e",
  null
  
)

export default component.exports